import React from 'react';

import TaskChip from 'containers/TaskDetails/components/TaskStatusChip';

import { TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import { StyledSelect } from 'components/Input/styles';

import { StyledMenuItem } from './styles';
import { TaskStatusSelectProps } from './types';

const TaskStatusSelect: React.FunctionComponent<TaskStatusSelectProps> = ({ onChange, ...props }) => (
  <StyledSelect
    {...props}
    fullWidth
    onChange={(event) => onChange(event.target.value as TaskStatus)}
    $withoutBorder={props.withoutBorder}
    inputProps={props.disableIconComponent ? { IconComponent: () => null } : {}}
  >
    <StyledMenuItem key={TaskStatus.ToDo} value={TaskStatus.ToDo}>
      <TaskChip status={TaskStatus.ToDo} />
    </StyledMenuItem>
    <StyledMenuItem key={TaskStatus.CantDo} value={TaskStatus.CantDo}>
      <TaskChip status={TaskStatus.CantDo} />
    </StyledMenuItem>
    <StyledMenuItem key={TaskStatus.InProgress} value={TaskStatus.InProgress}>
      <TaskChip status={TaskStatus.InProgress} />
    </StyledMenuItem>
    <StyledMenuItem key={TaskStatus.Completed} value={TaskStatus.Completed}>
      <TaskChip status={TaskStatus.Completed} />
    </StyledMenuItem>
  </StyledSelect>
);

export default TaskStatusSelect;
